// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmOptions {
  onAccept?: () => void;
  onReject?: () => void;
}

export interface ConfirmationData {
  message: string;
  options: ConfirmOptions;
  title: string
  resolver: (value: boolean) => void;
  meta?: any;
}

@Injectable({ providedIn: 'root' })
export class ConfirmationPopupService {
  private confirmationSubject = new Subject<ConfirmationData>();
  confirmation$ = this.confirmationSubject.asObservable();

  open(message: string, options: ConfirmOptions = {}, title: string = 'Confirm', meta?: any): Promise<boolean> {
    return new Promise(resolve => {
      this.confirmationSubject.next({
        message,
        options,
        title,
        resolver: resolve,
        meta
      });
    });
  }
}
